module.exports = __webpack_public_path__ + "img/progress_017.b2208b48.png";